import { TFunction } from "i18next";
import * as Yup from "yup";

export const getImprovementPlanFormSchema = (t: TFunction) =>
    Yup.object().shape({
        title: Yup.string()
            .required(t("common:form.requiredFieldForm")),
        status: Yup.number()
            .required(t("common:form.requiredFieldForm"))
            .min(1, t("common:form.requiredFieldForm")),
        originId: Yup.number()
            .nullable()
            .notRequired(),
        typeId: Yup.number()
            .nullable()
            .notRequired(),
        startDate: Yup.date()
            .nullable()
            .notRequired(),
        endDate: Yup.date()
            .nullable()
            .when("startDate", ([startDate], schema) =>
                startDate
                    ? schema.test(
                        "endDate-after-startDate",
                        t("common:form.messageErrorFinishDateBeforeStartDate"),
                        (endDate) => {
                            if (!endDate) return true;
                            return endDate.getTime() > startDate.getTime();
                        }
                    )
                    : schema
            )
            .notRequired(),
        selectedFunctionalAreas: Yup.array()
            .of(Yup.number())
            .nullable()
            .notRequired(),
        selectedServices: Yup.array()
            .of(Yup.number())
            .nullable()
            .notRequired(),
        objectives: Yup.array()
            .of(
                Yup.object().shape({
                    id: Yup.number().required(),
                    description: Yup.string()
                        .trim()
                        .required(t("common:form.requiredFieldForm")),
                })
            )
            .nullable()
            .notRequired(),
    });


